// Production requests stay on the website's origin so Safari/PWAs can use
// first-party HttpOnly cookies. Vercel forwards /api to Railway.
const loopback = ['localhost', '127.0.0.1', '[::1]'].includes(window.location.hostname);
export const API_BASE = loopback ? (process.env.REACT_APP_API_URL || 'http://localhost:3001') : '';
